export const VirtualPagePaths = {
	DE: {
		// Login flow
		AUTO_LOGIN: '/ratenkredit/auto-login',
		AUTO_LOGIN_ERROR: '/ratenkredit/auto-login-error',
		LOGIN_START_FORM: '/ratenkredit/login-start-form',
		LOGIN_OTP_FORM: '/ratenkredit/login-otp-form',
		LOGIN_ERROR: '/ratenkredit/login-error',
		LOGIN_COMPLETE: '/ratenkredit/login-complete',
		// Application steps
		PERSONAL_DATA: '/ratenkredit/personal-data',
		PSD2: '/ratenkredit/psd2',
		LOAN_OFFER: '/ratenkredit/loan-offer',
		SIGN_PN: '/ratenkredit/sign-pn',
		UPLOAD_DOCUMENTS: '/ratenkredit/upload-documents',
		THANK_YOU: '/ratenkredit/thank-you',
		DISBURSED: '/ratenkredit/disbursed',
		REVIEWED: '/ratenkredit/reviewed',
	},
	IT: {
		// Login flow
		AUTO_LOGIN: '/cashloan/auto-login',
		AUTO_LOGIN_ERROR: '/cashloan/auto-login-error',
		LOGIN_START_FORM: '/cashloan/login-start-form',
		LOGIN_OTP_FORM: '/cashloan/login-otp-form',
		LOGIN_ERROR: '/cashloan/login-error',
		LOGIN_COMPLETE: '/cashloan/login-complete',
		// Application steps
		PERSONAL_DATA: '/cashloan/personal-data',
		PERSONAL_DATA_STEP_1: '/cashloan/personal-data-step-1',
		PERSONAL_DATA_STEP_2: '/cashloan/personal-data-step-2',
		PSD2_INFO: '/cashloan/psd2-info',
		PSD2: '/cashloan/psd2',
		LOAN_OFFER: '/cashloan/loan-offer',
		SIGN_PN: '/cashloan/sign-pn',
		UPLOAD_DOCUMENTS: '/cashloan/upload-documents',
		THANK_YOU: '/cashloan/thank-you',
		DISBURSED: '/cashloan/disbursed',
		REVIEWED: '/cashloan/reviewed',
	},
} as const
